module.exports = __webpack_public_path__ + "img/a_la_carte.41db00d9.png";